import { Dialog, Grid } from '@mui/material';
import HotelFiltersContent from './HotelFiltersContent';

const HotelFiltersDialog = ({
  fullScreen,
  open,
  handleClose,
  hotelSearchResults,
  setFilter,
  handelFilterAplicated,
  priceRange,
  setPriceRange,
  pricesFiltered,
  setPricesFiltered,
  filter,
  totalNights,
  orderHotelsBy,
  handleSetOrderHotelsBy,
  handleClearFilterAplicated,
}) => {
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-label="Filtros de hoteles"
      keepMounted
    >
      <Grid style={{ display: 'flex', flexDirection: 'column' }}>
        <HotelFiltersContent
          hotelSearchResults={hotelSearchResults.hotels}
          setFilter={setFilter}
          handelFilterAplicated={handelFilterAplicated}
          priceRange={priceRange}
          setPriceRange={setPriceRange}
          pricesFiltered={pricesFiltered}
          setPricesFiltered={setPricesFiltered}
          filter={filter}
          handleClose={handleClose}
          totalNights={totalNights}
          orderHotelsBy={orderHotelsBy}
          handleSetOrderHotelsBy={handleSetOrderHotelsBy}
          handleClearFilterAplicated={handleClearFilterAplicated}
        />
      </Grid>
    </Dialog>
  );
};

export default HotelFiltersDialog;
